'use strict';

namespace Core {
    class CheckboxArray {
        // Attr
        list: any[];
        value: any;

        constructor (
            private $scope: ng.IScope
        ) {
        }

        init(el): void {

            const checkbox: ng.IAugmentedJQuery = el;

            // watch checkbox changes
            checkbox.change(() => {
                const index = this.indexOfVal(this.list, this.value);
                // modify the list
                let action: () => any = index > -1
                    ? () => this.list.splice(index, 1)
                    : () => this.list.push(this.value);
                this.$scope.$apply(action());
            });

            // watch the list
            this.$scope.$watchCollection('ca.list', (list) => {
                // sync checkbox state to the list
                if (list) {
                    const checked = this.indexOfVal(list, this.value) > -1;
                    checkbox.prop('checked', checked);
                }
            });

        }

        private indexOfVal(array, value) {
            return _.findIndex(array, (i) => {
                return value === String(i) || _.isEqual(value, i);
            });
        }

    }
    angular
        .module('core')
        .directive('checkboxArray', (): ng.IDirective => {
            return {
                restrict: 'A',
                controller: CheckboxArray,
                controllerAs: 'ca',
                bindToController: {
                    list: '=checkboxArray',
                    value: '='
                },
                link: (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attrs: ng.IAttributes,
                    controller : CheckboxArray
                ) => {
                    controller.init(el);
                }
            };
        });
}
